var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 15C13.4477 15 13 15.4477 13 16C13 16.5523 13.4477 17 14 17V15ZM19 16H20C20 15.4477 19.5523 15 19 15V16ZM18 21C18 21.5523 18.4477 22 19 22C19.5523 22 20 21.5523 20 21H18ZM14 17H19V15H14V17ZM18 16V21H20V16H18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58203 14.9971C5.14272 16.3848 6.08146 17.5874 7.29157 18.4682C8.50169 19.3491 9.93462 19.8727 11.4275 19.9797C12.9204 20.0868 14.4134 19.7728 15.7368 19.0736C17.0601 18.3744 18.1608 17.318 18.9137 16.0244",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9C10.5523 9 11 8.55228 11 8C11 7.44772 10.5523 7 10 7V9ZM5 8H4C4 8.55228 4.44772 9 5 9V8ZM6 3C6 2.44772 5.55228 2 5 2C4.44772 2 4 2.44772 4 3H6ZM10 7H5V9H10V7ZM6 8V3H4V8H6Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4176 9.00315C18.8569 7.61541 17.9182 6.41278 16.7081 5.53197C15.498 4.65116 14.065 4.12749 12.5721 4.02048C11.0792 3.91346 9.58624 4.2274 8.26287 4.92661C6.9395 5.62582 5.83882 6.68226 5.08594 7.97584",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.4d836fb54022d190874f8fa6869983b7.svg";
export { ForwardRef as ReactComponent };